<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400" :class="{'secondBox-borrom':$route.path === '/question' || $route.path === '/protocol'}">
      <div class="logo">
        <!-- <img
          :src="require('@/page/vatintecnologiacm/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        /> -->
        <span class="title">VATIN TECNOLOGIA</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Pagina de inicio</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/about' }" class="Li2">
          <router-link to="/about" class="nav-link2">
            <span class="routeText2">Sobre nosotros</span>
          </router-link>
        </li>
        <!-- <li :class="{ 'active-link': $route.path === '/introduce1' }" class="Li3">
          <router-link to="/introduce1" class="nav-link3">
            <span class="routeText3">Vấn đề thường gặp</span>
          </router-link>
        </li> -->
        <li
          class="dropdown Li3"
          :class="{
            'active-link':
              $route.path === '/introduce1' || $route.path === '/introduce2'|| $route.path === '/introduce3' || $route.path === '/introduce4'|| $route.path === '/introduce5'  
             
          }"
        >
          <!-- 添加下拉图标 -->
          <router-link to="/introduce1" class="nav-link3">
            <span class="dropdown-toggle routeText3">Nuestro servicio</span>
          </router-link>
          <ul class="dropdown-menu" ref="dropdownMenu">
            <li
            style="color: red;"
              :class="{
                'active-link1': $route.path === '/introduce1',
              }"
            >
              <router-link to="/introduce1" class="dropdown-toggle routeText6">
                Desarrollar soluciones de software
              </router-link>
            </li>
            <div class="dropdown-item-line"></div>
            <li
              :class="{
                'active-link1': $route.path === '/introduce2',
              }"
            >
              <router-link to="/introduce2" class="dropdown-toggle routeText7">
                Inteligencia artificial y aprendizaje automático
              </router-link>
            </li>
            <div class="dropdown-item-line"></div>
            <li
              :class="{
                'active-link1': $route.path === '/introduce3',
              }"
            >
              <router-link to="/introduce3" class="dropdown-toggle routeText8">
                Servicios de Asesoría Técnica
              </router-link>
            </li>
            <div class="dropdown-item-line"></div>
            <li
              :class="{
                'active-link1': $route.path === '/introduce4',
              }"
            >
              <router-link to="/introduce4" class="dropdown-toggle routeText9">
                La seguridad cibernética
              </router-link>
            </li>
            <div class="dropdown-item-line"></div>
            <li
              :class="{
                'active-link1': $route.path === '/introduce5',
              }"
            >
              <router-link to="/introduce5" class="dropdown-toggle routeText10">
                Atención al cliente y servicio
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- <div style="height: 130px"></div> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
  height:90px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  /* height: 90px; */
  padding: 0 15px;
  background-color: #27004E;
  /* box-shadow: 0px 2px 28px rgba(50, 55, 71, 0.10); */
  /* box-shadow: 0px 2px 10px rgba(50, 55, 71, 0.10); */
  /* background-image: url("@/page/vatintecnologiacm/components/img/NavBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
}

.secondBox-borrom{
  box-shadow: 0px 1.5px 0px rgba(54, 53, 56, 1);
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
  margin-left: 30px;
}

.title {
  width: 500px;
  font-size: 18px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #FFFFFF;
  /* line-height: 23px; */
  padding-left: 17px;
  /* text-transform: uppercase; */
  height: 24px;
  line-height: 35px;
  /* height: 90px;
  line-height: 90px; */
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #FFFFFF;
  /* line-height: 29px; */
  /* text-transform: uppercase; */
}



.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;

  margin: 0 auto;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-left: 4px;
  padding-right: 4px;
  padding: 6px;
  height: 39px;
  /* line-height: 90px; */
}
.Li1 {
  width: 190px;
}
.Li2 {
  width: 190px;
}
.Li3 {
  width: 200px;
}
.Li4 {
  width: 250px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}
.Li5 {
  width: 210px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}
.active-link {
  /* border-color: #782AFC;
  background-color: #782AFC; */
  /* border-radius: 40px; */
  /* border-radius: 9px; */
  /* border-radius: 24px; */
  /* border: 1px solid #FFFFFF; */
  background-image: url("@/page/vatintecnologiacm/components/img/NavActive.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;
  color: #FFFFFF;
}
.title{
  /* border: 1px solid red; */
  /* padding-left: 50px; */
  width: 280px
}
.secondBox{
  padding: 0 160px;
}

.dropdown {
  position: relative;
}

.dropdown-toggle {
  cursor: pointer;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #3e005b;
  border: 1px solid rgba(178, 142, 255, 1);
  padding: 5px 0;
  min-width: 330px;
  border-radius: 10px;
}

.dropdown-menu li {
  /* height: 40px;
  line-height: 40px; */
  /* border: 1px solid red; */
}
/* .dropdown-menu li:hover {
  padding: 5px 10px;
  border-bottom: 1px solid #3742aa;
} */
.dropdown-menu li:hover {
  /* background-color: #f0f0f0; */
  /* color: #D095FFFF; */
}

.dropdown:hover .dropdown-menu {
  display: block;
}
/* .dropdown-menu li{
  color: #F0DDFFFF;
} */
.dropdown-menu li a {
  font-size: 14px;
  text-decoration: none;
  font-family: SF Pro-Semibold;
  /* font-weight: 550; */
  /* margin-top: 10px; */
}

.routeText6,
.routeText7,
.routeText8,
.routeText9,
.routeText10{
  width: 100%;
  text-align: center;
  color: #F0DDFFFF;
}
.active-link1 .routeText6,
.active-link1 .routeText7,
.active-link1 .routeText8,
.active-link1 .routeText9,
.active-link1 .routeText10
{
  color: #D095FFFF;
}
.dropdown-icon {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #000; /* 设置倒三角形的颜色 */
  border-bottom: none; /* 去除下边框 */
  margin-left: 5px;
  vertical-align: middle;
}
.dropdown-item-line{
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  width: 80%;
  margin-left: 10%;
}
</style>